import { render } from "./UsersTable.vue?vue&type=template&id=70c60a74"
import script from "./UsersTable.vue?vue&type=script&lang=js"
export * from "./UsersTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__